/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowTrendingUpIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M12.994 7.815a.907.907 0 1 1 0-1.815h7.909c.5 0 .907.406.907.907v7.91a.907.907 0 0 1-1.815 0V9.097l-6.36 6.36a.907.907 0 0 1-1.283 0l-3.313-3.313-5.29 5.29a.907.907 0 1 1-1.283-1.283l5.931-5.932a.907.907 0 0 1 1.284 0l3.313 3.313 5.718-5.718z" clipRule="evenodd" /></svg>;
};
export default ArrowTrendingUpIcon;